module.exports = __webpack_public_path__ + "img/shape-metal_af-gold@2x.7479da2c.png";